import {ngAsync} from 'shared/utils/ng-@decorators';
import {transferify, unRestangularize} from 'shared/utils/data-service-utils';
import type {LabeledIdentified} from 'typings/portaro.be.types';

export default class HistoricalPlacesDataService {
    public static serviceName = 'historicalPlacesDataService';

    private static readonly ROUTE = 'places-history';

    /*@ngInject*/
    constructor(private Restangular: Restangular.IService) {
    }

    @ngAsync()
    @unRestangularize()
    public async query(query: HistoricalPlacesRequest = {}): Promise<HistoricalPlace[]> {
        return this.Restangular
                   .all(HistoricalPlacesDataService.ROUTE)
                   .customPOST(transferify(query));
    }

    @ngAsync()
    @unRestangularize()
    public async getFormSettings(): Promise<any> {
        return this.Restangular
                   .one(HistoricalPlacesDataService.ROUTE, 'form')
                   .get();
    }


}

export interface HistoricalPlacesRequest {
    name?: string;
    place?: string;
    type?: ProvenienceType;
    yearRange?: {
        from: number,
        to: number
    };
    profession?: string;
    sex?: string;
}

export interface HistoricalPlace extends LabeledIdentified<string> {
    recordId: string;
    type: ProvenienceType;
    fromYear: number;
    toYear: number;
    coordinates: Coordinates;
    place: string;
    profession: string;
    sex: string;
}

export interface Coordinates {
    lat: number;
    lng: number;
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface ProvenienceType extends LabeledIdentified<string> {

}